module.exports = __webpack_public_path__ + "media/frames/frame_brown_horizontal-676c373e.jpg";